import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ToastProvider } from './components/Toast';
import { SoundProvider } from './contexts/SoundContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <SoundProvider>
      <ToastProvider>
        <App />
      </ToastProvider>
    </SoundProvider>
  </React.StrictMode>
);